import { Card, CardHeader, Col, Input, Label, Row } from "reactstrap";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import AppModal from "../../Common/AppModal";
import Select from "../../Common/AppSelect";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import {
  createBillableJobItem,
  createBillableJobItemSuccess,
  getBillableJobItemsList,
  readSingleJob,
  updateBillableJobItem,
  updateBillableJobItemSuccess,
} from "../../../store/singleJob/action";

import { getProductUnitTypeList } from "../../../store/product/action";
import classnames from "classnames";
import { formatVatPercent } from "../../../helpers/functions/formatVatPercent";
import { getProductListNewApiCall } from "../../../store/products/action";
import { isManualPriceProduct } from "../../../helpers/productManualPrice";
import { useParams } from "react-router-dom";
import { getJobInvoiceItemTemplateList } from "../../../store/invoiceCrmIT/action";
import {
  createJobInvoiceItemTemplateApiCall,
  jobInvoiceItemAiGenerateApiCall,
} from "../../../helpers/fakebackend_helper";
import { components as reactSelectComponents } from "react-select";
// Change #100067 - retired products are not offered when adding a line.
import { isProductActive } from "../../../helpers/functions/productActive";

export default function CreateEditBillableItems({
  isEdit,
  modal,
  setModal,
  toggle,
  Job_Id, // Required
  updateData,
  Customer_Id,
}) {
  const DefaultCompanyConfig = JSON.parse(
    localStorage.getItem("authUser")
  )?.get_configitem_data;
  const DefaultVATRate = DefaultCompanyConfig?.ZCONFIGVAL_13_X;
  const handleDefaultVatNumber = () => {
    if (isEmpty(DefaultVATRate)) {
      return 20;
    } else {
      return Number(DefaultVATRate);
    }
  };
  const dispatch = useDispatch();

  const defaultData = {
    LID: 1,
    Job_Id,
    Product_Id: "",
    Title: "",
    Description: "",
    Quantity: null,
    AmountLocalEach: "",
    AmountLocalSubTotal: "",
    AmountLocalVat: "",
    AmountLocalTotal: "",
    AmountVatPercentage: handleDefaultVatNumber() + "%",
    UnitType_Id: "",
    showItem: true,
  };

  const [createEditData, setCreateEditData] = useState([defaultData]);
  console.log("createEditData", createEditData);
  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(updateData)) return;
    setCreateEditData([
      {
        LID: 1,
        Id: updateData?.Id,
        Job_Id: updateData?.Job_Id,
        Product_Id: updateData?.Product_Id,
        Title: updateData?.Title,
        Description: updateData?.Description,
        Quantity: updateData?.Quantity,
        AmountLocalEach: updateData?.AmountLocalEach,
        AmountLocalSubTotal: updateData?.AmountLocalSubTotal,
        AmountLocalVat: updateData?.AmountLocalVat,
        AmountLocalTotal: updateData?.AmountLocalTotal,
        // Change #100420 - was seeding the raw DECIMAL ("20.000000").
        AmountVatPercentage: formatVatPercent(updateData?.AmountVatPercentage),
        UnitType_Id: updateData?.UnitType_Id,
        showItem: true,
      },
    ]);
  }, [updateData, isEdit]);

  // Change #100494 - AI wording for a line in this popup, the same as the
  // convert-to-invoice rewrite and the list's magic button (#100206). Two
  // modes: "job" writes it from the job (a new line has no Id yet, so it
  // sends the job instead), "rewrite" tidies what is already typed. With a
  // description in the box the button offers both; with none it goes
  // straight to the job. It only fills the boxes; nothing is saved until
  // Create / Update.
  const [aiLoadingIndex, setAiLoadingIndex] = useState(null);
  const [aiMenu, setAiMenu] = useState(null); // { anchor, index }
  const handleAiButton = (event, index) => {
    if (aiLoadingIndex !== null) return;
    if (String(createEditData[index]?.Description || "").trim()) {
      setAiMenu({ anchor: event.currentTarget, index });
    } else {
      handleAiWrite(index, "job");
    }
  };
  const handleAiWrite = async (index, mode) => {
    setAiMenu(null);
    if (aiLoadingIndex !== null) return;
    const line = createEditData[index];
    setAiLoadingIndex(index);
    try {
      const res = await jobInvoiceItemAiGenerateApiCall([
        mode === "rewrite"
          ? {
              Mode: "rewrite",
              Title: line?.Title || "",
              Description: line?.Description || "",
            }
          : line?.Id
          ? { Id: line.Id }
          : { Job_Id: line?.Job_Id || Job_Id },
      ]);
      if (res?.status !== 200) {
        toast.error(res?.message || "Could not generate the wording");
        return;
      }
      setCreateEditData((prevState) =>
        prevState.map((data, i) =>
          i === index
            ? {
                ...data,
                Title: res.Title || data.Title,
                Description: res.Description || data.Description,
              }
            : data
        )
      );
    } catch (err) {
      toast.error("Could not generate the wording");
    } finally {
      setAiLoadingIndex(null);
    }
  };

  const handleCreateUpdateData = (type) => {
    //check if createEditData.map( item => item.Quantity) is empty if it is return and toast error
    if (createEditData.some((item) => item.Quantity === null)) {
      toast.error("Quantity is required for all Products");
      return;
    }

    if (type === "crate") {
      const createData = createEditData.map((item) => {
        return {
          ...item,
          AmountVatPercentage: item?.AmountVatPercentage?.replace("%", ""),
          AmountLocalSubTotal: (
            item?.Quantity * item?.AmountLocalEach
          )?.toFixed(2),
          AmountLocalVat: (
            (item?.Quantity *
              item?.AmountLocalEach *
              item?.AmountVatPercentage?.replace("%", "")) /
            100
          )?.toFixed(2),
          AmountLocalTotal: (
            item?.Quantity * item?.AmountLocalEach +
            (item?.Quantity *
              item?.AmountLocalEach *
              item?.AmountVatPercentage?.replace("%", "")) /
              100
          )?.toFixed(2),
        };
      });
      dispatch(createBillableJobItem([createData]));
    } else {
      // same again map trough the data and remove % sign
      const updateData = createEditData.map((item) => {
        return {
          ...item,
          AmountVatPercentage: item?.AmountVatPercentage?.replace("%", ""),
          AmountLocalSubTotal: (
            item?.Quantity * item?.AmountLocalEach
          )?.toFixed(2),
          AmountLocalVat: (
            (item?.Quantity *
              item?.AmountLocalEach *
              item?.AmountVatPercentage?.replace("%", "")) /
            100
          )?.toFixed(2),
          AmountLocalTotal: (
            item?.Quantity * item?.AmountLocalEach +
            (item?.Quantity *
              item?.AmountLocalEach *
              item?.AmountVatPercentage?.replace("%", "")) /
              100
          )?.toFixed(2),
        };
      });
      dispatch(updateBillableJobItem([updateData]));
    }
  };

  const {
    billableJobItemCreateSuccessAPI,
    billableJobItemUpdateSuccessAPI,
    billableJobItemUpdateSuccessLoading,
    billableJobItemCreateSuccessLoading,
  } = useSelector((state) => ({
    billableJobItemCreateSuccessAPI:
      state.SingleJob.billableJobItemCreateSuccess,
    billableJobItemUpdateSuccessAPI:
      state.SingleJob.billableJobItemUpdateSuccess,
    billableJobItemUpdateSuccessLoading:
      state.SingleJob.billableJobItemUpdateSuccessLoading,
    billableJobItemCreateSuccessLoading:
      state.SingleJob.billableJobItemCreateSuccessLoading,
  }));
  const params = useParams();
  // Create success
  useEffect(() => {
    if (isEmpty(billableJobItemCreateSuccessAPI)) return;
    if (billableJobItemCreateSuccessAPI?.status === 200) {
      dispatch(
        getBillableJobItemsList([
          {
            job_data: {
              Id: Job_Id,
            },
          },
        ])
      );
      if (params.id) {
        dispatch(readSingleJob(params));
      }
      toast.success(billableJobItemCreateSuccessAPI?.message);
      setModal(false);
      setCreateEditData(defaultData);
      dispatch(readSingleJob({ id: Job_Id }));
    } else {
      toast.error(billableJobItemCreateSuccessAPI?.message);
    }
    dispatch(createBillableJobItemSuccess([]));
  }, [billableJobItemCreateSuccessAPI]);

  // Update success
  useEffect(() => {
    if (isEmpty(billableJobItemUpdateSuccessAPI)) return;
    if (billableJobItemUpdateSuccessAPI?.status === 200) {
      dispatch(
        getBillableJobItemsList([
          {
            job_data: {
              Id: Job_Id,
            },
          },
        ])
      );
      dispatch(readSingleJob({ id: Job_Id }));
      toast.success(billableJobItemUpdateSuccessAPI?.message);
      setModal(false);
      setCreateEditData(defaultData);
    } else {
      toast.error(billableJobItemUpdateSuccessAPI?.message);
    }
    dispatch(updateBillableJobItemSuccess([]));
  }, [billableJobItemUpdateSuccessAPI]);

  const { productList } = useSelector((state) => ({
    productList: state.Products.productsListNewApiCall?.product_list,
  }));
  const { invoiceItemTemplateListAPI, invoiceItemTemplateListLoading } =
    useSelector((state) => ({
      invoiceItemTemplateListAPI:
        state.InvoiceCrmIT.invoiceItemTemplateList?.jobinvoiceitemtemplate_list,
      invoiceItemTemplateListLoading:
        state.InvoiceCrmIT.invoiceItemTemplateListLoading,
    }));
  console.log("invoiceItemTemplateListAPI", invoiceItemTemplateListAPI);

  useEffect(() => {
    dispatch(getProductListNewApiCall());
    dispatch(getProductUnitTypeList());
    dispatch(getJobInvoiceItemTemplateList());
  }, []);

  const [productListApi, setProductListApi] = useState([]);

  useEffect(() => {
    if (isEmpty(productList)) return;

    const tempb = productList
      // 1. Filter products where AllowJobBillableItem === 1
      .filter((p) => p?.AllowJobBillableItem === "1")

      // 2. Sort by Order first, then by Title
      .sort((a, b) => {
        if ((a?.Order ?? 0) !== (b?.Order ?? 0)) {
          return (a?.Order ?? 0) - (b?.Order ?? 0);
        }
        return (a?.Title || "").localeCompare(b?.Title || "");
      });

    setProductListApi(tempb);
  }, [productList]);

  const { productUnitTypeList } = useSelector((state) => ({
    productUnitTypeList: state.ProductCrmIT.productUnitTypeList?.unittype_list,
  }));

  const [activeTab, setActiveTab] = useState("open");
  // Same reasoning as the Predicted Billing modal - see there. Kept in step
  // deliberately: these two screens sit next to each other on a job and are
  // operated as one (Task 24555).
  const handleDuplicateBillableItem = (index) => {
    setCreateEditData((prevState) => {
      const source = prevState[index];
      if (!source) return prevState;
      const nextLid =
        Math.max.apply(
          Math,
          prevState.map((o) => o.LID || 0)
        ) + 1;
      const { Id, Source, ...copyable } = source;
      const copy = { ...copyable, LID: nextLid, showItem: true };
      const next = prevState.map((data) => ({ ...data, showItem: false }));
      next.splice(index + 1, 0, copy);
      return next;
    });
  };

  const handleAddNew = () => {
    // set all showItem to false
    setCreateEditData((prevState) => {
      return prevState.map((data) => {
        return {
          ...data,
          showItem: false,
        };
      });
    });

    let localLID = 0;
    // check if there is any data if not set LID to 1 else fin max number of LID and add 1
    if (isEmpty(createEditData)) {
      localLID = 1;
    } else {
      localLID = Math.max.apply(
        Math,
        createEditData.map(function (o) {
          return o.LID;
        })
      );
      localLID = localLID + 1;
    }

    setCreateEditData((prevState) => {
      return [
        ...prevState,
        {
          LID: localLID,
          Job_Id,
          Product_Id: "",
          Title: "",
          Description: "",
          Quantity: "",
          AmountLocalEach: "",
          AmountLocalSubTotal: "",
          AmountLocalVat: "",
          AmountLocalTotal: "",
          AmountVatPercentage: handleDefaultVatNumber() + "%",
          UnitType_Id: "",
          showItem: true,
        },
      ];
    });
  };
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // Making a template from what is on the form (Task 24544). The dropdown could
  // only ever pick an existing one, so building the same set of lines a second
  // time meant retyping it - and there is no other screen that creates these.
  //
  // Kept inline under the dropdown rather than as a second dialog: this already
  // IS a dialog, and stacking one on another to type a single name is worse than
  // the problem.
  const [showNewTemplate, setShowNewTemplate] = useState(false);
  const [newTemplateName, setNewTemplateName] = useState("");
  const [savingTemplate, setSavingTemplate] = useState(false);

  const handleSaveAsTemplate = async () => {
    const name = newTemplateName.trim();
    if (!name) {
      toast.error("Give the template a name");
      return;
    }

    // A template is a set of products, so only lines that actually name one can
    // go in it. Saying so beats silently saving an empty template.
    const templateItems = (createEditData || [])
      .filter((item) => item?.Product_Id)
      .map((item, index) => ({
        Product_Id: Number(item.Product_Id),
        Order: index + 1,
      }));

    if (isEmpty(templateItems)) {
      toast.error(
        "Add at least one line with a product before saving a template"
      );
      return;
    }

    setSavingTemplate(true);
    try {
      const res = await createJobInvoiceItemTemplateApiCall([
        { Name: name, jobinvoiceitemtemplateitem_list: templateItems },
      ]);
      if (res?.status === 200) {
        toast.success(res?.message || "Template created");
        setShowNewTemplate(false);
        setNewTemplateName("");
        dispatch(getJobInvoiceItemTemplateList());
      } else {
        toast.error(res?.message || "Could not create the template");
      }
    } catch (err) {
      toast.error("Could not create the template");
    } finally {
      setSavingTemplate(false);
    }
  };

  // react-select's menu with an action pinned under the options, which is where
  // "none of these are what I want" gets noticed.
  const TemplateMenuList = (menuProps) => (
    <reactSelectComponents.MenuList {...menuProps}>
      {menuProps.children}
      <div className="border-top p-2">
        <button
          type="button"
          className="btn btn-sm btn-soft-primary w-100"
          onMouseDown={(e) => {
            // mouseDown, not click: react-select closes the menu on blur and the
            // click would never land.
            e.preventDefault();
            e.stopPropagation();
            setShowNewTemplate(true);
          }}
        >
          <i className="ri-add-line align-bottom me-1" />
          Create a new template from these lines
        </button>
      </div>
    </reactSelectComponents.MenuList>
  );
  console.log("selectedTemplate", selectedTemplate);
  const handleLoadLoadTemplate = () => {
    //if selectedTemplate is null return
    if (!selectedTemplate) return;

    const templateArray = invoiceItemTemplateListAPI?.find(
      (item) => +item?.Id === +selectedTemplate
    )?.jobinvoiceitemtemplateitem_list;
    console.log("templateArray", templateArray);
    // we map trough array and create new billable items based on template
    let localLID = 1;
    //selecting template always creates new billable items

    const newBillableItems = templateArray?.map((product) => {
      return {
        LID: localLID++,
        Job_Id,
        Product_Id: product?.Product_Id,
        Title: "", // productListApi?.find((item) => item?.Id === product?.Product_Id)?.Name,
        Description: "", //productListApi?.find((item) => item?.Id === product?.Product_Id)?.Description,
        Quantity: productListApi?.find(
          (item) => item?.Id === product?.Product_Id
        )?.QuantityDefault,
        AmountLocalEach: productListApi
          ?.find((item) => item?.Id === product?.Product_Id)
          ?.productpricing_list?.find(
            (item) => item?.Customer_Id === Customer_Id
          )?.AmountLocalSubTotal
          ? productListApi
              ?.find((item) => item?.Id === product?.Product_Id)
              ?.productpricing_list?.find(
                (item) => item?.Customer_Id === Customer_Id
              )?.AmountLocalSubTotal
          : productListApi?.find((item) => item?.Id === product?.Product_Id)
              ?.AmountLocalSubTotal,
        AmountLocalSubTotal: productListApi
          ?.find((item) => item?.Id === product?.Product_Id)
          ?.productpricing_list?.find(
            (item) => item?.Customer_Id === Customer_Id
          )?.AmountLocalSubTotal
          ? productListApi
              ?.find((item) => item?.Id === product?.Product_Id)
              ?.productpricing_list?.find(
                (item) => item?.Customer_Id === Customer_Id
              )?.AmountLocalSubTotal
          : productListApi?.find((item) => item?.Id === product?.Product_Id)
              ?.AmountLocalSubTotal,
        //calculate vat
        AmountLocalVat: (
          ((productListApi //if vat is set in product pricing use that else use default vat
            ?.find((item) => item?.Id === product?.Product_Id)
            ?.productpricing_list?.find(
              (item) => item?.Customer_Id === Customer_Id
            )?.AmountVatPercentage
            ? productListApi
                ?.find((item) => item?.Id === product?.Product_Id)
                ?.productpricing_list?.find(
                  (item) => item?.Customer_Id === Customer_Id
                )?.AmountVatPercentage
            : productListApi?.find((item) => item?.Id === product?.Product_Id)
                ?.AmountVatPercentage) *
            (productListApi
              ?.find((item) => item?.Id === product?.Product_Id)
              ?.productpricing_list?.find(
                (item) => item?.Customer_Id === Customer_Id
              )?.AmountLocalSubTotal
              ? productListApi
                  ?.find((item) => item?.Id === product?.Product_Id)
                  ?.productpricing_list?.find(
                    (item) => item?.Customer_Id === Customer_Id
                  )?.AmountLocalSubTotal
              : productListApi?.find((item) => item?.Id === product?.Product_Id)
                  ?.AmountLocalSubTotal)) /
          100
        )?.toFixed(2),
        AmountLocalTotal:
          //calculate total
          (productListApi
            ?.find((item) => item?.Id === product?.Product_Id)
            ?.productpricing_list?.find(
              (item) => item?.Customer_Id === Customer_Id
            )?.AmountLocalSubTotal
            ? productListApi
                ?.find((item) => item?.Id === product?.Product_Id)
                ?.productpricing_list?.find(
                  (item) => item?.Customer_Id === Customer_Id
                )?.AmountLocalSubTotal
            : productListApi?.find((item) => item?.Id === product?.Product_Id)
                ?.AmountLocalSubTotal) *
          productListApi
            ?.find((item) => item?.Id === product?.Product_Id)
            ?.productpricing_list?.find(
              (item) => item?.Customer_Id === Customer_Id
            )?.AmountVatPercentage
            ? productListApi
                ?.find((item) => item?.Id === product?.Product_Id)
                ?.productpricing_list?.find(
                  (item) => item?.Customer_Id === Customer_Id
                )?.AmountVatPercentage
            : productListApi?.find((item) => item?.Id === product?.Product_Id)
                ?.AmountVatPercentage
            ? productListApi?.find((item) => item?.Id === product?.Product_Id)
                ?.AmountVatPercentage
            : handleDefaultVatNumber(),
        AmountVatPercentage: productListApi
          ?.find((item) => item?.Id === product?.Product_Id)
          ?.productpricing_list?.find(
            (item) => item?.Customer_Id === Customer_Id
          )?.AmountVatPercentage
          ? productListApi
              ?.find((item) => item?.Id === product?.Product_Id)
              ?.productpricing_list?.find(
                (item) => item?.Customer_Id === Customer_Id
              )?.AmountVatPercentage + "%"
          : productListApi?.find((item) => item?.Id === product?.Product_Id)
              ?.AmountVatPercentage
          ? productListApi?.find((item) => item?.Id === product?.Product_Id)
              ?.AmountVatPercentage + "%"
          : handleDefaultVatNumber() + "%",
        UnitType_Id: productListApi?.find(
          (item) => item?.Id === product?.Product_Id
        )?.UnitType_Id,
        showItem: true,
      };
    });
    setCreateEditData(newBillableItems);
  };
  return (
    <>
      <AppModal
        open={modal}
        onClose={toggle}
        title={isEdit ? "Edit Billable Item" : "Create Billable Item"}
        icon={<ReceiptOutlinedIcon />}
        headerAccent="indigo"
        size="sm"
        loading={
          billableJobItemUpdateSuccessLoading ||
          billableJobItemCreateSuccessLoading
        }
        loadingText="Saving…"
        submitLabel={isEdit ? "Update" : "Create"}
        submitColor="success"
        onSubmit={() =>
          isEdit
            ? handleCreateUpdateData("update")
            : handleCreateUpdateData("crate")
        }
      >
        {!isEdit && (
          <div className={"my-2"}>
            <Label>Select Template</Label>
            <div className={"d-flex"}>
              <Select
                className={"w-100 me-2"}
                components={{ MenuList: TemplateMenuList }}
                options={
                  !isEmpty(invoiceItemTemplateListAPI)
                    ? invoiceItemTemplateListAPI?.map((item) => ({
                        label: item?.Name,
                        value: item?.Id,
                        id: item?.Id,
                      }))
                    : []
                }
                onChange={(e) => {
                  setSelectedTemplate(e?.value);
                }}
              ></Select>
              <div className={""}>
                <button
                  onClick={() => {
                    handleLoadLoadTemplate();
                  }}
                  className={"btn btn-info w-100"}
                >
                  Select
                </button>
              </div>
            </div>

            {showNewTemplate && (
              <div className={"d-flex mt-2"}>
                <Input
                  className={"me-2"}
                  placeholder={"New template name"}
                  value={newTemplateName}
                  autoFocus
                  onChange={(e) => setNewTemplateName(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSaveAsTemplate();
                    }
                  }}
                />
                <button
                  type="button"
                  className={"btn btn-success me-2"}
                  disabled={savingTemplate}
                  onClick={handleSaveAsTemplate}
                >
                  {savingTemplate ? "Saving…" : "Save"}
                </button>
                <button
                  type="button"
                  className={"btn btn-light"}
                  disabled={savingTemplate}
                  onClick={() => {
                    setShowNewTemplate(false);
                    setNewTemplateName("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        )}

        {createEditData?.map((item, index) => (
          <Card key={index} className={"p-3"}>
            <CardHeader className={"cursor-pointer"}>
              <div className={"d-flex flex-row justify-content-between"}>
                <div
                  className={"d-flex flex-row"}
                  onClick={() => {
                    setCreateEditData((prevState) => {
                      return prevState.map((data, i) => {
                        if (i === index) {
                          return {
                            ...data,
                            showItem: !data.showItem,
                          };
                        }
                        return data;
                      });
                    });
                  }}
                >
                  <div className={"me-2"}>
                    <i
                      className={classnames("fa", {
                        "fa-chevron-down": item.showItem,
                        "fa-chevron-right": !item.showItem,
                      })}
                    ></i>
                  </div>
                  <div>
                    <div>
                      #{item?.LID} -{" "}
                      {
                        productListApi?.find(
                          (product) => product?.Id === item?.Product_Id
                        )?.Name
                      }
                    </div>
                    <div>{item?.Title}</div>
                  </div>
                </div>
                <div className={"d-flex flex-row gap-2"}>
                  <div onClick={() => handleDuplicateBillableItem(index)}>
                    <div
                      title={"Duplicate Billable Item"}
                      className={
                        "btn btn-sm btn-soft-secondary d-flex align-items-center"
                      }
                      style={{ padding: "5px 7px" }}
                    >
                      <i className="fa-regular fa-copy"></i>
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      setCreateEditData((prevState) => {
                        return prevState.filter((data, i) => i !== index);
                      });
                    }}
                  >
                    <div
                      title={"Remove Billable Item"}
                      className={
                        "btn btn-sm btn-danger d-flex align-items-center"
                      }
                      style={{ padding: "5px 7px" }}
                    >
                      <i className="fa-regular fa-trash-can"></i>
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
            {item.showItem && (
              <Row className="g-3">
                <>
                  <Col lg={12}>
                    <Label>Product</Label>
                    <Select
                      placeholder={"Choose Product"}
                      className="mb-0 job-select2"
                      value={
                        item?.Product_Id
                          ? {
                              label: productListApi?.find(
                                (product) => product?.Id === item?.Product_Id
                              )?.Name,
                              value: item?.Product_Id,
                              id: item?.Product_Id,
                            }
                          : []
                      }
                      onChange={(e) => {
                        console.log(
                          "e",
                          productListApi?.find(
                            //set unit type
                            (item) => item?.Id === e?.value
                          )?.QuantityDefault !== null
                            ? productListApi?.find(
                                (item) => item?.Id === e?.value
                              )?.QuantityDefault
                            : null
                        );
                        setCreateEditData((prevState) => {
                          return prevState.map((data, i) => {
                            if (i === index) {
                              return {
                                ...data,
                                Product_Id: e?.value,
                                // Manual-price products (equipment and the
                                // like) carry no standard price, so their
                                // product price is 0 and seeding it wipes
                                // whatever was typed here (Task 24551).
                                AmountLocalEach: isManualPriceProduct(
                                  productListApi?.find(
                                    (item) => item?.Id === e?.value
                                  )
                                )
                                  ? data?.AmountLocalEach
                                  : productListApi
                                      ?.find(
                                        //set price each
                                        (item) => item?.Id === e?.value
                                      )
                                      ?.productpricing_list?.find(
                                        (item) =>
                                          item?.Customer_Id === Customer_Id
                                      )?.AmountLocalSubTotal
                                  ? productListApi
                                      ?.find(
                                        //set price each
                                        (item) => item?.Id === e?.value
                                      )
                                      ?.productpricing_list?.find(
                                        (item) =>
                                          item?.Customer_Id === Customer_Id
                                      )?.AmountLocalSubTotal
                                  : productListApi?.find(
                                      //set price each
                                      (item) => item?.Id === e?.value
                                    )?.AmountLocalSubTotal,
                                AmountVatPercentage: productListApi
                                  ?.find(
                                    //set price each
                                    (item) => item?.Id === e?.value
                                  )
                                  ?.productpricing_list?.find(
                                    (item) => item?.Customer_Id === Customer_Id
                                  )?.AmountVatPercentage
                                  ? productListApi
                                      ?.find(
                                        //set vat
                                        (item) => item?.Id === e?.value
                                      )
                                      ?.productpricing_list?.find(
                                        (item) =>
                                          item?.Customer_Id === Customer_Id
                                      )?.AmountVatPercentage + "%"
                                  : productListApi?.find(
                                      //set price each
                                      (item) => item?.Id === e?.value
                                    )?.AmountVatPercentage
                                  ? productListApi?.find(
                                      //set price each
                                      (item) => item?.Id === e?.value
                                    )?.AmountVatPercentage + "%"
                                  : handleDefaultVatNumber() + "%",
                                UnitType_Id: productListApi?.find(
                                  //set unit type
                                  (item) => item?.Id === e?.value
                                )?.UnitType_Id,
                                Quantity:
                                  productListApi?.find(
                                    //set unit type
                                    (item) => item?.Id === e?.value
                                  )?.QuantityDefault !== null
                                    ? productListApi?.find(
                                        (item) => item?.Id === e?.value
                                      )?.QuantityDefault
                                    : null,
                              };
                            }
                            return data;
                          });
                        });
                      }}
                      options={
                        !isEmpty(productListApi)
                          ? productListApi?.filter(isProductActive).map((item) => ({
                              label: item?.Name,
                              value: item?.Id,
                              id: item?.Id,
                            }))
                          : []
                      }
                      id="country-select"
                    ></Select>
                  </Col>
                  <Col lg={12}>
                    <Label>Title</Label>
                    <div>
                      <Input
                        type={"text"}
                        placeholder={"Enter Title"}
                        value={item.Title}
                        onChange={(e) => {
                          setCreateEditData((prevState) => {
                            return prevState.map((data, i) => {
                              if (i === index) {
                                return {
                                  ...data,
                                  Title: e.target.value,
                                };
                              }
                              return data;
                            });
                          });
                        }}
                      />
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="d-flex align-items-center justify-content-between">
                      <Label>Description</Label>
                      <button
                        type="button"
                        className="btn btn-sm btn-soft-info mb-2"
                        title="AI - write the title and description from the job"
                        disabled={aiLoadingIndex !== null}
                        onClick={(e) => handleAiButton(e, index)}
                      >
                        {aiLoadingIndex === index ? (
                          <span className="spinner-border spinner-border-sm me-1" />
                        ) : (
                          <i className="ri-magic-line align-bottom me-1" />
                        )}
                        Write with AI
                      </button>
                      <Menu
                        anchorEl={aiMenu?.index === index ? aiMenu.anchor : null}
                        open={aiMenu?.index === index}
                        onClose={() => setAiMenu(null)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <MenuItem onClick={() => handleAiWrite(index, "rewrite")}>
                          <ListItemIcon>
                            <i className="ri-edit-2-line" />
                          </ListItemIcon>
                          <ListItemText
                            primary="Rewrite the current description"
                            secondary="Tidies the wording already in the box"
                          />
                        </MenuItem>
                        <MenuItem onClick={() => handleAiWrite(index, "job")}>
                          <ListItemIcon>
                            <i className="ri-briefcase-line" />
                          </ListItemIcon>
                          <ListItemText
                            primary="Generate a new description from the job"
                            secondary="Written from the job, its notes and tasks"
                          />
                        </MenuItem>
                      </Menu>
                    </div>
                    <div>
                      <textarea
                        placeholder={"Enter Description"}
                        //100 width
                        className={"form-control"}
                        value={item.Description}
                        onChange={(e) => {
                          setCreateEditData((prevState) => {
                            return prevState.map((data, i) => {
                              if (i === index) {
                                return {
                                  ...data,
                                  Description: e.target.value,
                                };
                              }
                              return data;
                            });
                          });
                        }}
                        //2 line
                        rows={2}
                      />
                    </div>
                  </Col>

                  <Col lg={12}>
                    <Label>Unit Type</Label>
                    <Select
                      className="mb-0 job-select2"
                      value={
                        item.UnitType_Id
                          ? {
                              label: productUnitTypeList?.find(
                                (unitProduct) =>
                                  unitProduct?.Id === item?.UnitType_Id
                              )?.Name,
                              value: item?.UnitType_Id,
                              id: item?.UnitType_Id,
                            }
                          : []
                      }
                      onChange={(e) => {
                        setCreateEditData((prevState) => {
                          return prevState.map((data, i) => {
                            if (i === index) {
                              return {
                                ...data,
                                UnitType_Id: e?.value,
                              };
                            }
                            return data;
                          });
                        });
                      }}
                      options={
                        !isEmpty(productUnitTypeList)
                          ? productUnitTypeList?.map((unitProduct) => ({
                              label: unitProduct?.Name,
                              value: unitProduct?.Id,
                              id: unitProduct?.Id,
                            }))
                          : []
                      }
                      id="country-select"
                    ></Select>
                  </Col>
                  <Col lg={4}>
                    <Label>Quantity</Label>
                    <div>
                      <Input
                        type={"number"}
                        placeholder={"Enter Quantity"}
                        value={item?.Quantity ?? ""}
                        onChange={(e) => {
                          setCreateEditData((prevState) => {
                            return prevState.map((data, i) => {
                              if (i === index) {
                                return {
                                  ...data,
                                  Quantity: e.target.value,
                                };
                              }
                              return data;
                            });
                          });
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <Label>Each</Label>
                    <div>
                      <Input
                        type={"number"}
                        placeholder={"Price Each"}
                        value={item?.AmountLocalEach}
                        onChange={(e) => {
                          setCreateEditData((prevState) => {
                            return prevState.map((data, i) => {
                              if (i === index) {
                                return {
                                  ...data,
                                  AmountLocalEach: e.target.value,
                                };
                              }
                              return data;
                            });
                          });
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <Label>VAT</Label>
                    <div>
                      <Input
                        type={"text"}
                        placeholder={"VAT %"}
                        value={item?.AmountVatPercentage}
                        onChange={(e) => {
                          setCreateEditData((prevState) => {
                            return prevState.map((data, i) => {
                              if (i === index) {
                                return {
                                  ...data,
                                  AmountVatPercentage: e.target.value,
                                };
                              }
                              return data;
                            });
                          });
                        }}
                        onFocus={(e) => {
                          setCreateEditData((prevState) => {
                            return prevState.map((data, i) => {
                              if (i === index) {
                                return {
                                  ...data,
                                  AmountVatPercentage: e.target.value.replace(
                                    "%",
                                    ""
                                  ),
                                };
                              }
                              return data;
                            });
                          });
                        }}
                        onBlur={(e) => {
                          setCreateEditData((prevState) => {
                            return prevState.map((data, i) => {
                              if (i === index) {
                                return {
                                  ...data,
                                  AmountVatPercentage: e.target.value + "%",
                                };
                              }
                              return data;
                            });
                          });
                        }}
                      />
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className={"pt-2"}>
                      <div>
                        <span>
                          <strong>Sub Total:</strong> £
                          {(item?.Quantity * item?.AmountLocalEach)?.toFixed(2)}
                        </span>
                      </div>
                      <div>
                        <span>
                          <strong>VAT: </strong>£
                          {(
                            (item?.Quantity *
                              item?.AmountLocalEach *
                              item?.AmountVatPercentage?.replace("%", "")) /
                            100
                          )?.toFixed(2)}
                        </span>
                      </div>
                      <div>
                        <span>
                          <strong>Total:</strong> £
                          {(
                            item?.Quantity * item?.AmountLocalEach +
                            (item?.Quantity *
                              item?.AmountLocalEach *
                              item?.AmountVatPercentage?.replace("%", "")) /
                              100
                          )?.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </Col>
                </>
              </Row>
            )}
          </Card>
        ))}
        {!isEdit && (
          <Row className={"mt-2"}>
            <Col lg={12}>
              <div className={"d-flex justify-content-start "}>
                <button
                  onClick={handleAddNew}
                  className={"btn btn-primary"}
                  style={{ marginRight: "10px" }}
                >
                  Add Billable Item
                </button>
              </div>
            </Col>
          </Row>
        )}
      </AppModal>
    </>
  );
}
